import { FC } from 'react';

import Image from './image.svg';

export const PolygonLogo: FC = () => <img src={Image} alt="polygon" width="26px" height="26px" />;
